import { useEffect, useState } from 'react';

import { listLeadSource } from 'services/Settings';
import { totalCountEvent } from 'services/generalServices';

export function useLeadSource(
  excludeFromLoading = false,
  options = {},
  loadFullList = true,
  limit = 15,
  leadSourceValue = '',
  isLandingPage = false
) {
  const [List, setList] = useState([]);
  const [isLeadSourceLoading, setIsLeadSourceLoading] = useState(false);
  const [nextToken, setNextToken] = useState('');

  const loadLeadSources = async (limit = 15, pagination_token = '', pagination_direction = 'forward', inputValue = '') => {
    setIsLeadSourceLoading(true);
    try {
      let pageLimit = limit;
      if (loadFullList) {
        const response = await totalCountEvent('lead_source');
        pageLimit = response?.data;
      }
      const response = await listLeadSource(pageLimit, pagination_token, pagination_direction, excludeFromLoading, inputValue);
      if (response?.data?.lead_source?.length) {
        const activeLeadSources = response?.data?.lead_source?.filter((item) => item?.status === 'ACTIVE' || item?.status === undefined);
        // setList(response?.data?.lead_source);
        setList(activeLeadSources);
        return response?.data;
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLeadSourceLoading(false);
    }
  };

  useEffect(() => {
    loadLeadSources();
  }, []);

  return { leadSourceList: List, isLeadSourceLoading, loadLeadSources, leadSourceToken: nextToken };
}
